// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__c7SGu","row":"Node_row__3bImG","label":"Node_label__2-tA2","footer":"Node_footer__ojQcm"};